import React, { useState } from "react";
import Navbar from "../../../components/navbar/navbar";
import TitleSection from "../../../components/title-section/title-section";
import Footer from "../../../components/footer/Footer";
import "./aeromexico-cargo.css";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../../../components/scrollToTop/scrollToTop";
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import Helmet from "react-helmet";
import Information from "../../home-amc/information/information";
import BreadCrumb from "../../../components/breadcrumb/breadcrumb";
import imgBg from "../../../assets/imgs/about-us/bg-nosotros.png";
import { FaAngleLeft, FaAngleRight, FaAngleDown } from "react-icons/fa6";
import pinkLines from "../../../assets/imgs/track/lines.svg";

function AeromexicoCargo() {
  const [tAeroMexicoCargo] = useTranslation("aboutUs");
  const [tSMetaData] = useTranslation("metaData");
  const [showMore, setShowMore] = useState(false);
  const [animClass, setAnimClass] = useState("start");
  const [indexText, setIndexText] = useState(0);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"]["about-us"]}/${
      Object.keys(navBarEs["about-us"])[0]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"]["about-us"]}/${
      Object.keys(navBarEn["about-us"])[0]
    }`
  );

  const textInformatio = [
    {
      "year": 1989,
      "title_img": "Aeroméxico y Mexicana",
      "subtitle_img": "Aeroméxico y Mexicana crean la empresa Aeromexpress S.A. de C.V., donde se concentraría la actividad de carga de ambas aerolíneas.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 1990,
      "title_img": "Aeroméxico",
      "subtitle_img": "Se inicia la explotación de las panzas de aeronaves de Aeroméxico.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 1992,
      "title_img": "Expansión Internacional",
      "subtitle_img": "Lanzamiento de operaciones cargueras USA/MEX.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 1994,
      "title_img": "IATA",
      "subtitle_img": "Se constituye Aeromexpress SA de CV como la primer Línea Aérea Carguera en México, logrando obtener de IATA la autorización bajo el código QO y el prefijo 976.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 1998,
      "title_img": "Cargolux",
      "subtitle_img": "Convenio comercial con Cargolux, aerolínea carguera más grande de Europa, para operar rutas entre EUA y México.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 2005,
      "title_img": "Korean Air Cargo",
      "subtitle_img": "Korean Air Cargo, la aerolínea carguera más grande del mundo, designa a Aeromexpress como su representante general de ventas en México.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 2007,
      "title_img": "Crecimiento sin Igual",
      "subtitle_img": "Aeromexpress se consolida como el mayor operador logístico en México. Comercializando vuelos cargueros en itinerario regular, operaciones charter y el manejo de carga en las panzas de 200 aviones de Aeroméxico y Mexicana.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 2012,
      "title_img": "Aeroméxico Cargo",
      "subtitle_img": "Aeromexpress evoluciona y se transforma en Aeroméxico Cargo. Empresa líder en el mercado de carga aérea en México.",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      }
    },
    {
      "year": 2021,
      "title_img": "Aeroméxico3",
      "subtitle_img": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "title_text": "Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      "texts": {
        "li": ["Durante la pandemia, se reaizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd. El modelo operó del 24 de marzo de 2020 a finales de mayo 2022 aprovechando la flora de aviones de pasajeros que en ese momento se encontraba subutilizada.", "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros." ],
        "paragraph": {
          "p1": "Algunas de las rutas más emblematicas fueron desde: Shenzhen, Shanghái, Jamaica, Hong Kong, Moscú, entre otros.",
          "p2": "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      },
    },
  ]

  const changeInfo = (type, index) => {
    setAnimClass("end");

    setTimeout(() => {
      if(type === "minus") {
        setIndexText((prevIndex) => (prevIndex + 1) % textInformatio.length);
      } else if(type === "plus") {
        setIndexText((prevIndex) => (prevIndex - 1 + textInformatio.length) % textInformatio.length);
      } else if(type === "custom") {
        setIndexText(index);
      }
      setAnimClass("start");
    }, 1000);
  }

  const pinkStatusPoint = (index) => {
    if(index <= indexText) {
      return "pink";
    }
    return "";
  }

  const pinkStatusLine = () => {
    const mediumValue = parseFloat(((indexText + 1) + (indexText + 2)) / 2);
    const minValue = 1;
    const maxValue = textInformatio.length;

    let finalPercent = ((mediumValue - minValue) / (maxValue - minValue)) * 100;

    if(finalPercent > 100) {
      finalPercent = 100
    }
    return `${finalPercent}%`
  }

  return (
    <>
      <Helmet>
        <title>{tSMetaData("nosotros.title")}</title>
        <meta name="description" content={tSMetaData("nosotros.description")} />
      </Helmet>
      <ScrollToTop />
      <Information />
      <Navbar />
      <BreadCrumb />
      <TitleSection title={tAeroMexicoCargo("title.title-page")} />
      
      
      <div className="our-container-img">
        <div className="bg-opacity"></div>
        <img src={imgBg} alt="Aeromexico Cargo" />
        <button className="arrow-left arrow" onClick={() => changeInfo("plus")}><FaAngleLeft /></button>
        <button className="arrow-right arrow" onClick={() => changeInfo("minus")}><FaAngleRight /></button>

        <div className="info-text">
          <h3 className={`tit_anim_1 ${animClass}`}>{textInformatio[indexText].year}</h3>
          <h5 className={`sbt_anim_1 ${animClass}`}>{textInformatio[indexText].title_img}</h5>
          <p className={`txt_anim_1 ${animClass}`}>{textInformatio[indexText].subtitle_img}</p>
        </div>

        <div className="checkpoint-content">
          <div className="checkpoint">
            <div className="line-pink" style={{ width: pinkStatusLine() }}></div>
            <div className="line"></div>

            {textInformatio.map((item, index) => (
              <div className="item-content" key={index}>
                <div className={`circle ${pinkStatusPoint(index)}`} onClick={() => changeInfo('custom', index)}></div>
                <p className="text">{item.year}</p>
              </div>
            ))}

          </div>
        </div>
      </div>

      <div className="amc-out-title">
        <h4>{textInformatio[indexText].title_text}</h4>
        <img src={pinkLines} />
      </div>

      <div className="cnt-global-info-our">
        <button className="btn-height" onClick={() => changeInfo("plus")}><FaAngleLeft /></button>
        <div>
          <div className={!showMore ? "amc-our-information" : "amc-our-information collapsed"}>
            <p className="principal-text text-center">
              {textInformatio[indexText].texts.paragraph.p1}
            </p>
            <ul className="principal-text mt-2">
              {textInformatio[indexText].texts.li.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <p className="principal-text text-center mt-4">{textInformatio[indexText].texts.paragraph.p2}</p>
            
          </div>
          
          <div className="content-btn-our">
            <button className="show-more-our" onClick={() => setShowMore(!showMore)}>
              LEER MÁS <div className={showMore ? "icon rotate-180" : "icon"}><FaAngleDown /></div>
            </button>
          </div>
        </div>

        <button className="btn-height" onClick={() => changeInfo("minus")}><FaAngleRight /></button>
      </div>

      <Footer />
    </>
  );
}

export default AeromexicoCargo;
